export default "__VITE_ASSET__I2tt3yuS__"